export default "__VITE_ASSET__cc5dd287__"